// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deal-taxes-template_graph__Nyg06 {
    text-align: center;
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    row-gap: 40px;
    height: 110vh;
}

.deal-taxes-template_graphContainer__qalBx {
    width: 100%;
    padding-right: 12%;
}

.deal-taxes-template_graph__Nyg06 svg {
    max-width: 1250px;
    width: 100%;
    height: auto;
    margin: auto auto 0;
    max-height: calc(100vh - var(--header-height) - 140px);
}

.deal-taxes-template_actions__wgsPu {
    display: flex;
    column-gap: 169px;
    row-gap: 16px;
    flex-wrap: wrap;
}

.deal-taxes-template_btn__GR8Iq {
    color: #fff;
    border: 1px solid var(--primary-color);
    background: var(--primary-color);
    border-radius: 22px;
    font-size: 16px;
    cursor: pointer;
    padding: 10px 10px;
    transition: background-color 0.4s, border-color 0.4s;
    width: 170px;
    margin: auto auto 0;
    text-align: center;
    height: 44px;
    line-height: initial;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.deal-taxes-template_btn__GR8Iq:hover {
    background-color: var(--primary-color-active);

    border-color: var(--primary-color-active);
    color: #fff;
}

.deal-taxes-template_container__1W073 {
    width: 100%;
    margin: 0 auto;
    position: relative;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 50px;
}

.deal-taxes-template_pageHeader__DKOCR {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #7b848e;
    margin-bottom: 12px;
}

.deal-taxes-template_pageHeader__DKOCR h2 {
    margin: 0 0 23px;
    font-size: 20px;
}

.deal-taxes-template_sectionWrapper__tZVtY {
    max-height: calc(100vh - 350px);
    margin-bottom: 40px;
    padding-right: 10px;
}

.deal-taxes-template_table__2Cxsg {
    width: 100%;
}

.deal-taxes-template_table__2Cxsg th {
    position: sticky;
    top: 0;
    background: #fbfbfb;
}

.deal-taxes-template_table__2Cxsg th:not(.deal-taxes-template_empty__6VWIM):after {
    content: '';
    display: block;
    border-top: 1px solid #7b848e;
    height: 8px;
    margin-top: 4px;
}

.deal-taxes-template_table__2Cxsg th:first-child:after {
    margin-left: -10px;
}

.deal-taxes-template_table__2Cxsg th:last-child:after {
    margin-right: -10px;
}

.deal-taxes-template_table__2Cxsg th.deal-taxes-template_empty__6VWIM:after {
    opacity: 0;
}

.deal-taxes-template_tableContainer__pxYq7 td {
    font-size: 12px !important;
    line-height: 16px;
    padding: 2px 4px !important;
}

.deal-taxes-template_bold__z\\+BEy {
    font-weight: 700;
}

.deal-taxes-template_right__ZD8rr {
    text-align: right;
}

.deal-taxes-template_left__2X-9q {
    text-align: left;
}

.deal-taxes-template_comments__yi33O {
    width: 402px;
    text-align: left;
}

.deal-taxes-template_highlight__5TuFw {
    background: rgba(22, 80, 180, 0.1);
}

.deal-taxes-template_highlightRed__s2QxO {
    background: rgba(253, 111, 33, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/pages/DealTaxesTemplate/deal-taxes-template.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sDAAsD;AAC1D;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,sCAAsC;IACtC,gCAAgC;IAChC,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,oDAAoD;IACpD,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,6CAA6C;;IAE7C,yCAAyC;IACzC,WAAW;AACf;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,6BAA6B;IAC7B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":[".graph {\n    text-align: center;\n    padding: 20px 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    row-gap: 40px;\n    height: 110vh;\n}\n\n.graphContainer {\n    width: 100%;\n    padding-right: 12%;\n}\n\n.graph svg {\n    max-width: 1250px;\n    width: 100%;\n    height: auto;\n    margin: auto auto 0;\n    max-height: calc(100vh - var(--header-height) - 140px);\n}\n\n.actions {\n    display: flex;\n    column-gap: 169px;\n    row-gap: 16px;\n    flex-wrap: wrap;\n}\n\n.btn {\n    color: #fff;\n    border: 1px solid var(--primary-color);\n    background: var(--primary-color);\n    border-radius: 22px;\n    font-size: 16px;\n    cursor: pointer;\n    padding: 10px 10px;\n    transition: background-color 0.4s, border-color 0.4s;\n    width: 170px;\n    margin: auto auto 0;\n    text-align: center;\n    height: 44px;\n    line-height: initial;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.btn:hover {\n    background-color: var(--primary-color-active);\n\n    border-color: var(--primary-color-active);\n    color: #fff;\n}\n\n.container {\n    width: 100%;\n    margin: 0 auto;\n    position: relative;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px 50px;\n}\n\n.pageHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid #7b848e;\n    margin-bottom: 12px;\n}\n\n.pageHeader h2 {\n    margin: 0 0 23px;\n    font-size: 20px;\n}\n\n.sectionWrapper {\n    max-height: calc(100vh - 350px);\n    margin-bottom: 40px;\n    padding-right: 10px;\n}\n\n.table {\n    width: 100%;\n}\n\n.table th {\n    position: sticky;\n    top: 0;\n    background: #fbfbfb;\n}\n\n.table th:not(.empty):after {\n    content: '';\n    display: block;\n    border-top: 1px solid #7b848e;\n    height: 8px;\n    margin-top: 4px;\n}\n\n.table th:first-child:after {\n    margin-left: -10px;\n}\n\n.table th:last-child:after {\n    margin-right: -10px;\n}\n\n.table th.empty:after {\n    opacity: 0;\n}\n\n.tableContainer td {\n    font-size: 12px !important;\n    line-height: 16px;\n    padding: 2px 4px !important;\n}\n\n.bold {\n    font-weight: 700;\n}\n\n.right {\n    text-align: right;\n}\n\n.left {\n    text-align: left;\n}\n\n.comments {\n    width: 402px;\n    text-align: left;\n}\n\n.highlight {\n    background: rgba(22, 80, 180, 0.1);\n}\n\n.highlightRed {\n    background: rgba(253, 111, 33, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"graph": `deal-taxes-template_graph__Nyg06`,
	"graphContainer": `deal-taxes-template_graphContainer__qalBx`,
	"actions": `deal-taxes-template_actions__wgsPu`,
	"btn": `deal-taxes-template_btn__GR8Iq`,
	"container": `deal-taxes-template_container__1W073`,
	"pageHeader": `deal-taxes-template_pageHeader__DKOCR`,
	"sectionWrapper": `deal-taxes-template_sectionWrapper__tZVtY`,
	"table": `deal-taxes-template_table__2Cxsg`,
	"empty": `deal-taxes-template_empty__6VWIM`,
	"tableContainer": `deal-taxes-template_tableContainer__pxYq7`,
	"bold": `deal-taxes-template_bold__z+BEy`,
	"right": `deal-taxes-template_right__ZD8rr`,
	"left": `deal-taxes-template_left__2X-9q`,
	"comments": `deal-taxes-template_comments__yi33O`,
	"highlight": `deal-taxes-template_highlight__5TuFw`,
	"highlightRed": `deal-taxes-template_highlightRed__s2QxO`
};
export default ___CSS_LOADER_EXPORT___;
